import { useEffect } from 'react';
import { useTheme } from '@mui/material';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { shouldApplyEdgeToEdgeFix } from '@ocx/utils-device';

export const useSetEdgeToEdgeBackgroundColor = () => {
  const theme = useTheme();

  useEffect(() => {
    const setEdgeToEdgeBackgroundColor = async () => {
      if (await shouldApplyEdgeToEdgeFix()) {
        EdgeToEdge.setBackgroundColor({ color: theme.palette.primary.main });
      }
    };

    setEdgeToEdgeBackgroundColor();
  }, [theme.palette.primary.main]);
};
